/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowForward: {
  name: 'arrow-forward';
  data: string;
} = {
  name: 'arrow-forward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/></svg>`
};
